module.exports = __webpack_public_path__ + "img/active-account.fb5434bb.svg";